module.exports = __webpack_public_path__ + "img/adam-prather.3bed0142.jpg";